module.exports = __webpack_public_path__ + "img/founder_link_box_dark.6ded4bdc.jpg";